import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notifyUser } from "components/shared-components/AdvancareNotification";
import phlebotomyService from "services/phlebotomyService";

export const initialState = {
  list: [],
  drawHistory: [],
  drawHistoryLoading: false,
  loading: false,
  creating: false,
  updating: false,
  errorMessages: [],
  showMessage: false,
};

export const phlebotomyFetch = createAsyncThunk(
  "/phlebotomyFetch",
  // console.log("fetching phlebotomy data")

  async (params, { rejectWithValue }) => {
    try {
      const response = await phlebotomyService.fetch(params);
      var code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const phlebotomyDrawHistory = createAsyncThunk(
  "/phlebotomyDrawHistory",
  async (sampleId, { rejectWithValue }) => {
    try {
      const response = await phlebotomyService.drawHistory(sampleId);
      var code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const phlebotomyAddTube = createAsyncThunk(
  "/phlebotomyAddTube",
  async (data, { rejectWithValue }) => {
    try {
      const response = await phlebotomyService.addTube(data);
      const code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const phlebotomyUpdate = createAsyncThunk(
  "/phlebotomyUpdate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await phlebotomyService.update(data);
      const code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      return rejectWithValue({ errorMessages: "Error updating the data" });
    }
  }
);

export const phlebotomySlice = createSlice({
  name: "phlebotomy",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
    updateDrawHistory: (state, action) => {
      state.drawHistory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(phlebotomyFetch.pending, (state) => {
        state.loading = true;
      })
      .addCase(phlebotomyFetch.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.datas;
      })
      .addCase(phlebotomyFetch.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(phlebotomyDrawHistory.pending, (state) => {
        state.drawHistoryLoading = true;
      })
      .addCase(phlebotomyDrawHistory.fulfilled, (state, action) => {
        state.drawHistoryLoading = false;
        state.drawHistory = action.payload.datas;
      })
      .addCase(phlebotomyDrawHistory.rejected, (state, action) => {
        notifyUser("info", "topRight", action.payload.errorMessages);
        state.drawHistoryLoading = false;
        state.drawHistory = [];
      })
      .addCase(phlebotomyAddTube.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(phlebotomyAddTube.fulfilled, (state, action) => {
        state.loading = false;
        notifyUser("success", "topRight", "Successfully Added");
      })
      .addCase(phlebotomyAddTube.rejected, (state, action) => {
        state.errorMessages = action.payload;
        state.loading = false;
        notifyUser("error", "topRight", action.payload);
      })
      .addCase(phlebotomyUpdate.pending, (state, action) => {
        state.updating = true;
      })
      .addCase(phlebotomyUpdate.fulfilled, (state, action) => {
        state.updating = false;
        notifyUser("success", "topRight", "Comment Updated Successfully");
      })
      .addCase(phlebotomyUpdate.rejected, (state, action) => {
        state.updating = false;
        notifyUser("error", "topRight", action.payload.errorMessages);
      });
  },
});

export const { showLoading } = phlebotomySlice.actions;

export default phlebotomySlice.reducer;
